export const translations = {
  en: {
    meta: {
      title: 'Rassd AI | AI Media Monitoring & Media Intelligence Platform',
      description: 'AI media monitoring platform for real-time brand monitoring, social media listening, sentiment analysis, brand mention tracking, competitor monitoring and media intelligence.',
      keywords: ''
    },
    nav: {
      links: ["Features", "Why Rassd", "Contact us"],
      login: "Log in",
    },
    hero: {
      title: "One place for all your news monitoring",
      subtitle:
        "Collect RSS feeds, read full articles, track social buzz, translate content, and extract metadata—personalities, countries, topics—in one powerful dashboard. Stay ahead with hot topics and live transcription.",
      viewDemo: "View demo",
      getStarted: "Get started",
    },
    features: {
      sectionTitle: "Everything you need to follow the news",
      items: [
        {
          title: "RSS Aggregation",
          desc: "Subscribe to any RSS feed and get all your sources in one unified stream, updated in real time.",
        },
        {
          title: "Full Articles & Images",
          desc: "Read complete articles without leaving the platform—no more juggling dozens of browser tabs.",
        },
        {
          title: "Social Media & Trending Topics",
          desc: "Monitor mentions, hashtags, and trending conversations across major social platforms.",
        },
        {
          title: "Translation & Transcription",
          desc: "Translate articles and social posts into your language with one click, powered by AI.",
        },
        {
          title: "Metadata Extraction",
          desc: "Automatically tag personalities, countries, and topics from every piece of content.",
        },
        {
          title: "Hot Topics",
          desc: "See what's trending right now with our real-time topic heat map and popularity scores.",
        },
        {
          title: "Analytics & Sentiment Analysis",
          desc: "Visualize coverage trends, source performance, and engagement metrics in beautiful charts.",
        },
        {
          title: "Smart Alerts",
          desc: "Set keyword or topic alerts and get notified the moment a story breaks.",
        },
      ],
    },
    why: {
      title: "Why teams choose Rassd?",
      subtitle:
        "Built for researchers, analysts, and newsrooms who need one place to see the full picture.",
      items: [
        {
          num: "01",
          title: "Save time",
          desc: "Stop switching between tools. Rassd brings every source into one place so your team can focus on analysis, not aggregation.",
        },
        {
          num: "02",
          title: "Go deeper",
          desc: "Full-text translations, complete summaries, and clickable data help you understand what you're reading—faster.",
        },
        {
          num: "03",
          title: "Stay ahead",
          desc: "RSS feeds, social media, and related content alerts keep you informed before something new breaks.",
        },
      ],
    },
    contact: {
      title: "Let's talk",
      subtitle:
        "For any inquiries, partnership requests, or support needs, please use the contact form below. Our team will handle your request with care and professionalism.",
    },
    form: {
      firstName: "First name",
      lastName: "Last name",
      email: "Email",
      subject: "Subject",
      message: "Message",
      submit: "Submit",
      sending: "Sending…",
      successTitle: "Message sent!",
      successDesc:
        "Thank you for reaching out. Our team will get back to you shortly.",
      sendAnother: "Send another message",
      errorAlert: "An error occurred. Please try again.",
      errors: {
        firstName: "First name is required",
        lastName: "Last name is required",
        email: "Email is required",
        emailInvalid: "Invalid email address",
        subject: "Subject is required",
        message: "Message is required",
      },
    },
    footer: "2026 © Rassd.ai. All rights reserved.",
  },

  ar: {
    meta: {
      title: 'رصد AI | منصة رصد إعلامي وذكاء إعلامي بالذكاء الاصطناعي',
      description: 'منصة رصد إعلامي بالذكاء الاصطناعي لمراقبة العلامة التجارية، الاستماع إلى وسائل التواصل الاجتماعي، تحليل المشاعر، تتبع ذكر العلامة التجارية، رصد المنافسين ومراقبة الأزمات الإعلامية.',
      keywords: ''
    },
    nav: {
      links: ["سمات", " رصد", "اتصل بنا"],
      login: "تسجيل الدخول",
    },
    hero: {
      title: "مكان واحد لجميع معلوماتك الإخبارية",
      subtitle:
        "اجمع تغذيات RSS، واقرأ المقالات كاملةً، وتابع النقاشات على وسائل التواصل الاجتماعي، وترجم المحتوى، واستخرج البيانات الوصفية—الشخصيات والدول والموضوعات—في لوحة تحكم واحدة قوية. ابقَ في الصدارة مع الموضوعات الرائجة والنقل الفوري.",
      viewDemo: "شاهد العرض التوضيحي",
      getStarted: "ابدأ الآن",
    },
    features: {
      sectionTitle: "كل ما تحتاجه لمتابعة الأخبار",
      items: [
        {
          title: "وجمع الخلاصات RSS",
          desc: "اشترك في أي تغذية RSS واحصل على جميع مصادرك في تدفق موحد يُحدَّث في الوقت الفعلي.",
        },
        {
          title: "المقالات والصور الكاملة",
          desc: "اقرأ المقالات كاملةً دون مغادرة المنصة—لا حاجة بعد الآن لعشرات علامات التبويب.",
        },
        {
          title: "وسائل التواصل الاجتماعي والاتجاهات الرائجة",
          desc: "راقب الإشارات والوسوم والمحادثات الرائجة عبر منصات التواصل الاجتماعي الكبرى.",
        },
        {
          title: "الترجمة والتدوين",
          desc: "ترجم المقالات والمنشورات إلى لغتك بنقرة واحدة، مدعومةً بالذكاء الاصطناعي.",
        },
        {
          title: "استخراج البيانات الوصفية",
          desc: "وضع علامات تلقائية للشخصيات والدول والموضوعات من كل محتوى.",
        },
        {
          title: "مواضيع ساخنة",
          desc: "تعرّف على ما يشغل الرأي العام الآن عبر خريطة حرارة الموضوعات في الوقت الفعلي.",
        },
        {
          title: "التحليلات وتحليل المشاعر",
          desc: "تصوير اتجاهات التغطية وأداء المصادر ومقاييس التفاعل في مخططات بيانية.",
        },
        {
          title: "التنبيهات",
          desc: "اضبط تنبيهات الكلمات المفتاحية أو الموضوعات وتلقَّ إشعاراً فور نشر خبر عاجل.",
        },
      ],
    },
    why: {
      title: "لماذا تختار الفرق رصد؟",
      subtitle:
        "مُصمَّم للباحثين والمحللين وغرف الأخبار الذين يحتاجون إلى مكان واحد لرؤية الصورة كاملة.",
      items: [
        {
          num: "١",
          title: "وفر الوقت",
          desc: "لا تحتاج بعد الآن لعشرات التبويب. يجمع رصد علامات التبويب، وسائل التواصل الاجتماعي، والإشعارات في موجز واحد عبر رصد.",
        },
        {
          num: "٢",
          title: "تعمق أكثر",
          desc: "تساعدك الترجمات النصية الكاملة والتكرارات والعلاقات الذكاء الاصطناعي على فهم الأحداث والقصص بدقة وسرعة.",
        },
        {
          num: "٣",
          title: "ابق في المقدمة",
          desc: "تسلسل الروافد الإخبارية والاهتمامات الاجتماعية الصور على ما هو جديد. يُبقيك التنبيهات الذكية مطلعاً دائماً قبل فوات الأوان.",
        },
      ],
    },
    contact: {
      title: "لنتحدث",
      subtitle:
        "لأي استفسارات أو طلبات شراكة أو احتياجات دعم، يُرجى استخدام نموذج الاتصال أدناه. سيتعامل فريقنا مع طلبك بعناية واحترافية.",
    },
    form: {
      firstName: "الاسم",
      lastName: "اللقب",
      email: "البريد الإلكتروني",
      subject: "الموضوع",
      message: "الرسلة",
      submit: "ارسال",
      sending: "جارٍ الإرسال…",
      successTitle: "تم الإرسال!",
      successDesc: "شكرًا لتواصلك معنا. سيرد فريقنا عليك في أقرب وقت.",
      sendAnother: "إرسال رسالة أخرى",
      errorAlert: "حدث خطأ. يُرجى المحاولة مرة أخرى.",
      errors: {
        firstName: "الاسم الأول مطلوب",
        lastName: "اسم العائلة مطلوب",
        email: "البريد الإلكتروني مطلوب",
        emailInvalid: "بريد إلكتروني غير صالح",
        subject: "الموضوع مطلوب",
        message: "الرسالة مطلوبة",
      },
    },
    footer: "٢٠٢٦ © Rassd.ai. جميع الحقوق محفوظة.",
  },
};